import { RouteConfig } from 'vue-router'

import digitalSportsIcon from '../assets/images/icon_menu_sports_digital_portrait@2x.png'
import digitalSportsIconActive from '../assets/images/icon_menu_sports_digital_portrait_active@2x.png'

const Layout = () => import('../views/Layout.vue')
const SubjectEvaluationLanding = () => import('../views/subject-evaluation/Landing.vue')
const SportsDigitalPortraitLanding = () => import('../views/sports-digital-portrait/Landing.vue')

export const subjectEvaluationLandingRoute: RouteConfig = {
  path: '/subject-evaluation-landing',
  name: 'subject_evaluation_landing',
  component: SubjectEvaluationLanding,
  meta: {
    title: '体育学科评价',
    showMenu: true,
  },
}

export const sportsDigitalPortraitLandingRoute: RouteConfig = {
  path: '/sports-digital-portrait-landing',
  name: 'sports_digital_portrait_landing',
  component: SportsDigitalPortraitLanding,
  meta: {
    title: '体育数字画像',
    showMenu: true,
  },
}

export default [
  {
    path: '/digital-sports',
    name: 'digital_sports',
    component: Layout,
    meta: {
      title: '数字体育',
      icon: digitalSportsIcon,
      iconActive: digitalSportsIconActive,
      showMenu: true,
    },
    children: [sportsDigitalPortraitLandingRoute, subjectEvaluationLandingRoute],
  },
]
